<!-- @format -->
<template>
    <div class="widget social-post-template-select-widget">
        <div class="widget-header">
            <h3>Choose Template</h3>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>
        <div class="content-wrapper">
            <p>Select an existing page</p>
            <selector-table
                v-model="selectedItems"
                item-container-title="Selected Templates"
                :is-initializing="isLoading"
                :items="availableItems"
                :selected-items="selectedItems"
                :selected-item-cell-config="selectedItemCellConfig"
                :table-config="tableConfig"
                @removed-item="handleRemovedItem"
                @remove-all="handleRemoveAll"
                @selected-item="handleSelectedItem"
                @query="handleQuery"
            />
        </div>
        <div class="widget-footer">
            <div class="cancel-container">
                <app-button class="transparent-btn" @click="closeWidget">Back</app-button>
            </div>
            <div class="action-container">
                <app-button :is-loading="isLoading" @click="add"> Add </app-button>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from '@/scripts/event-bus.js';
import { SocialPostTemplateBoardServiceMixin } from '@/mixins/board/social-post-template-board-service-mixin';

const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const SelectorTable = () => import('@/components/selector-table/selector-table');

export default {
    name: 'social-post-template-select-widget',

    components: {
        'app-button': AppButton,
        'selector-table': SelectorTable,
        'widget-close-svg': WidgetCloseSvg,
    },

    mixins: [SocialPostTemplateBoardServiceMixin],

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            isLoading: false,

            items: [],

            selectedItems: [],

            selectedItemCellConfig: {
                type: 'social-post-template-element',
            },

            tableConfig: [
                {
                    cellWidth: '500px',
                    id: 1,
                    label: 'Name',
                    type: 'social-post-template-element',
                    customHeaderStyles: {
                        justifyContent: 'left',
                        marginLeft: '130px',
                    },
                },
            ],
        };
    },

    computed: {
        availableItems() {
            return this.items.reduce((acc, item) => {
                if (
                    !(
                        this.selectedItems.length > 0 &&
                        this.selectedItems.some(({ id }) => id === item.id)
                    )
                ) {
                    acc.push(item);
                }
                return acc;
            }, []);
        },

        initialSelectedItems() {
            return this.widget.initialSelectedIds;
        },
    },

    created() {
        const initializeData = () => {
            return new Promise((resolve, reject) =>
                this.getData()
                    .then(() => {
                        if (this.initialSelectedItems.length) {
                            this.setInitialSelected(this.initialSelectedItems);
                        }
                        resolve();
                    })
                    .catch(reject),
            );
        };

        this.withLoadingBoundary(initializeData);
    },

    methods: {
        asTableItem(item) {
            return {
                id: item.id,
                name: item.postTemplate.name,
                thumbnailImageUrl: item.postTemplate.thumbnailImageUrl || null,
            };
        },

        handleQuery(options) {
            this.withLoadingBoundary(() => this.getData(options));
        },

        getData(options = {}) {
            this.items = [];

            return new Promise((resolve, reject) => {
                this.getSocialPostTemplates(options, null)
                    .then(({ items, totalItems }) => {
                        this.items = items.map(this.asTableItem);
                        this.totalItems = totalItems;
                        resolve();
                    })
                    .catch((error) => {
                        this.$helpers.showFailNotification(
                            'An error occurred while fetching your social post templates.',
                            { error },
                        );
                        reject();
                    });
            });
        },

        setInitialSelected() {
            this.selectedItems = this.items.filter(({ id }) =>
                this.initialSelectedItems.includes(id),
            );
        },

        handleRemoveAll() {
            this.selectedItems.splice(0, this.selectedItems.length);
        },

        handleRemovedItem(item) {
            this.selectedItems = this.selectedItems.filter(({ id }) => id !== item.id);
        },

        handleSelectedItem(item) {
            if (this.selectedItems.every(({ id }) => id !== item.id)) {
                this.selectedItems.push(item);
            }
        },

        add() {
            EventBus.$emit(
                'social-post-template:select',
                this.selectedItems.map((item) => item.id),
            );
            this.closeWidget();
        },

        withLoadingBoundary(promise) {
            this.isLoading = true;
            promise().finally(() => {
                this.isLoading = false;
            });
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },
    },
};
</script>

<style>
.social-post-template-select-widget .saving-step {
    text-align: center;
}

.social-post-template-select-widget .content-wrapper {
    padding: 17px !important;
}

.social-post-template-select-widget .cancel-container .btn.transparent-btn {
    background: transparent;
    border: 2px solid #cac6cb;
    color: #382153;
}

.social-post-template-select-widget .cancel-container .btn.transparent-btn:hover {
    background: #e1e0e5;
}
</style>
